"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubformRemoveTool = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var image_button_1 = require("../../../components/button/image.button");
var icons_1 = require("../../../components/icon/icons");
var modal_service_1 = require("../../../components/modal/modal.service");
var i18n_1 = require("../../../i18n");
var services_1 = require("../../../services");
var page_state_1 = require("../../../state/page.state");
var point_collection_cache_1 = require("../../topological.editor.map/point.collection.cache");
var SubformRemoveTool = /** @class */ (function () {
    function SubformRemoveTool() {
    }
    SubformRemoveTool.view = function (ctrl, collection) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.DELETE, {
            title: i18n_1.T.COLLECTION_EDIT_DELETE_SUBFORM,
            titleAttrs: { title: collection.schema.displayName },
            onclick: function (e) { return SubformRemoveTool.removeSubFormInstance(ctrl, e, collection); }
        });
    };
    SubformRemoveTool.removeSubFormInstance = function (ctrl, e, c) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.stopPropagation();
                        return [4 /*yield*/, modal_service_1.ModalService.open({
                                title: (0, i18n_1.Translate)(i18n_1.T.SUBFORM_REMOVE_TITLE, { title: c.formTitle }),
                                content: (0, i18n_1.Translate)(i18n_1.T.SUBFORM_REMOVE_CONFIRM, { title: c.schema.displayName }),
                                okName: i18n_1.T.SUBFORM_REMOVE_REMOVE,
                                hasCancel: true
                            })];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.doRemoveSubFormInstance(ctrl, c);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SubformRemoveTool.doRemoveSubFormInstance = function (ctrl, c) {
        page_state_1.CurrentState.cancelInteractions();
        c.parent.Mutator.remove(c.instanceId);
        // Update current capture if capture was removed with form (we dont update this if we are in TE)
        var captureIds = services_1.Services.Collection.getCaptureIds(c.collection);
        if (captureIds.indexOf(page_state_1.CurrentState.inspectedCaptureId) === -1 && ctrl.kind !== 'TopologicalEditorCollectionEditCtrl') {
            page_state_1.CurrentState.inspectedCaptureId = null;
        }
        if (ctrl.kind === 'TopologicalEditorCollectionEditCtrl') {
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(c.collection.revision);
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'subform:delete', c.instanceId);
    };
    tslib_1.__decorate([
        mobx_1.action
    ], SubformRemoveTool, "doRemoveSubFormInstance", null);
    return SubformRemoveTool;
}());
exports.SubformRemoveTool = SubformRemoveTool;
//# sourceMappingURL=subform.remove.tool.js.map